function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#A1BC0F",
  strokeWidth: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M100.3,55.5 c-1.8-2.4-3.5-4.7-5.2-6.9c0.1-0.1,0.2-0.3,0.3-0.4c0.6,0.3,1.3,0.5,1.8,0.9c5.3,3.4,10.6,6.8,16,10.1c0.6,0.4,1.4,0.5,2.1,0.6 c1.9,0.4,3.9,0.7,5.8,1.1c0,0.2,0,0.5,0,0.7c-1.9,0.4-3.8,1.1-5.7,1.2c-3.3,0.2-4.8,2.5-6.1,5c-0.2,0.5-0.1,1.5,0.2,1.9 c2.2,2.8,2,6,1.1,9.1c-1.5,5.4-4.4,10-9.5,12.7c-3.7,2-7.5,3.8-11.3,5.7c-0.2,0.1-0.3,0.2-0.5,0.2c-3.6,1.5-3.9,2.7-1.5,5.7 c1.4,1.7,2.8,3.5,4.3,5c1.9,1.9,4.4,2.8,7.1,2.8c0.7,0,1.3,0,2.3,0c-2.3,1.7-7.2,1.7-9.4,0.4c-0.6-0.4-1.5-0.5-2.2-0.6 c-2.6-0.1-5.3,0-7.9-0.5c2.8-0.3,5.6-0.6,8.6-0.9c-1.9-4.7-7.2-6.5-7.8-11.7c-2.3,1.7-4.5,1.7-6.8,0c1.9-0.3,3.6-0.6,5.4-0.9 c0-0.2,0-0.3,0.1-0.5c-0.5-0.2-1.1-0.5-1.6-0.6c-3.6-1-7.1-2.1-10.7-3c-4.5-1.1-9.1-0.3-13.4,0.9c-4.4,1.2-8.7,2.8-13.1,4.2 c-1.2,0.4-2.5,0.6-3.9,0.9c0.1-2.8,1.5-4.1,3.5-4.9c2.7-1.1,5.3-2.3,8-3.4c-0.1-0.1-0.3-0.2-0.4-0.3c0.3-0.5,0.5-1.3,0.9-1.5 c1.6-0.6,3.2-1.3,4.9-1.5c4.2-0.4,7.7-2.3,11.2-4.3C72.9,79,79,75.3,85.1,71.8c2-1.1,4.2-1.8,6.2-2.8c0.6-0.3,1.3-0.9,1.6-1.6 c0.7-1.5,1.2-3.1,1.8-4.6C95.9,59.9,97.3,57.2,100.3,55.5z"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
  fill: "none",
  stroke: "#A3BC1B",
  strokeWidth: 2.9954,
  strokeMiterlimit: 10,
  cx: 79.9,
  cy: 80,
  r: 77.2
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
  fill: "none",
  stroke: "#A3BC1B",
  strokeWidth: 2.5493,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeDasharray: "0,4.6077",
  cx: 79.9,
  cy: 80,
  r: 71.9
})));

function SvgIconLarkCircle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 159.9 160.1",
    enableBackground: "new 0 0 159.9 160.1",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLarkCircle);
export default __webpack_public_path__ + "static/media/icon-lark-circle.56a17943.svg";
export { ForwardRef as ReactComponent };